import { Box, Button, Container, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { m } from 'framer-motion';
import NextLink from 'next/link';
import Image from 'next/image';
import { MotionContainer, varFade } from 'src/components/animate';
import { PATH_AUTH } from 'src/routes/paths';

const RootStyle = styled(m.div)(({ theme }) => ({
  position: 'relative',
  marginBottom: 0,
  background: 'linear-gradient(104.03deg, #0C103A 100.91%, #3564CA 124.24%)',
  [theme.breakpoints.up('md')]: {
    top: 0,
    left: 0,
    width: 'auto',
    height: '100%',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
  },
}));

const OverlayImage = styled(Box)(({ theme }) => ({
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right',
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(4),
  width: '100%',
  position: 'relative',
  height: '100%'
}));

const OverlayBgImage = styled(Image)(() => ({
  position: 'relative',
}));


const OverlayContainer = styled(Container)(() => ({
  position: 'relative',
}));

const HeroImgStyle = styled(Image)(({ theme }) => ({
  zIndex: 8,
  width: '100%',
  position: 'relative',
  [theme.breakpoints.up('lg')]: {
    width: '100%',
    height: 'auto'
  }
}));

const ImageDirection = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end'
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: '58px',
  fontWeight: '700',
  lineHeight: '67.97px',
  color: theme.palette.common.white,
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(10),
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    fontWeight: '700',
    lineHeight: '32.81px',
    textAlign: 'center'
  }
}));

const CustomPrimaryTypography = styled(Typography)(({ theme }) => ({
  fontSize: '58px',
  fontWeight: '700',
  lineHeight: '67.97px',
  color: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    fontWeight: '700',
    lineHeight: '32.81px',
    textAlign: 'center'
  }
}));


const SetAlignmentButton = styled(m.div)(({ theme }) => ({
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center'
  }
}));

const CustomButton = styled(Button)(({ theme }) => ({
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    width: '100%',
    borderRadius: '3px'
  }
}));

// ----------------------------------------------------------------------

export default function HomeHero() {
  return (
    <>
      <MotionContainer>
        <RootStyle>
          <OverlayImage>
            <OverlayBgImage alt="" src="images/home/hero-bg.png" layout="fill"
              sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"/>
            <OverlayContainer>
              <Box>
                <Grid container>
                  <Grid item lg={7} md={12} sm={12} xs={12}>
                    <m.div variants={varFade().inRight}>
                      <CustomTypography variant="h2">
                        Asset Track for Cloud
                      </CustomTypography>
                      <CustomPrimaryTypography component="h3" variant="h3">
                        Advanced Asset and Resource Management and Tracking Solutions
                      </CustomPrimaryTypography>
                    </m.div>

                    <SetAlignmentButton variants={varFade().inRight}>
                      <NextLink href={PATH_AUTH.register} passHref>
                        <CustomButton
                          size="large"
                          variant="contained"
                          sx={{
                            my: 4
                          }}
                        >
                          Register Now
                        </CustomButton>
                      </NextLink>
                    </SetAlignmentButton>

                  </Grid>
                  <Grid sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} item lg={5} md={12} sm={12} xs={12}>
                    <ImageDirection>
                      <HeroImgStyle
                        alt="hero"
                        src="images/home/hero.png"
                        variants={varFade().inUp}
                        height="300"
                        width="500"
                      />
                    </ImageDirection>
                  </Grid>
                </Grid>
              </Box>
            </OverlayContainer>
          </OverlayImage>
        </RootStyle>
      </MotionContainer>
    </>
  );
}
